import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ReviewForm = ({ serviceId, onComplete }) => {
  const [comment, setComment] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [rating, setRating] = useState(1);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!comment.trim() || !jobDescription.trim()) {
      toast.error('Comment and job description are required');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}oosh/service/review/${serviceId}`, { comment, jobDescription, rating }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success('Review submitted');
      onComplete();
    } catch (err) {
      toast.error('Submit failed');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-blue-600">Submit Review</h2>
      <div className="grid grid-cols-1 gap-4">
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Your comment..."
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
          rows="4"
        />
        <textarea
          value={jobDescription}
          onChange={(e) => setJobDescription(e.target.value)}
          placeholder="Describe the job..."
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
          rows="4"
        />
        <select
          value={rating}
          onChange={(e) => setRating(Number(e.target.value))}
          className="p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        >
          {[1, 2, 3, 4, 5].map((r) => (
            <option key={r} value={r}>{r} Stars</option>
          ))}
        </select>
        <button
          onClick={submit}
          disabled={loading}
          className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600 disabled:opacity-50"
        >
          {loading ? 'Submitting...' : 'Submit Review'}
        </button>
      </div>
    </div>
  );
};

export default ReviewForm;